import IntegrationModal from "@/components/tools/IntegrationModal";
import TableHeader from "@/components/tools/TableHeader";
import { TRANSLATE_FIELD_INTEGRATION_MAP } from "@/constants/fields.js";
import {
  clearObject,
  get_error_msg,
  updateArrayItem
} from "@/functions/helpers";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  components: {
    IntegrationModal,
    TableHeader
  },
  data() {
    return {
      page: 1,
      search: "",
      modal: false,
      loading: false,
      integrationToEdit: null,
      columns: ["Produto", "Descrição", "Url", "Status", ""],
      breadcrumbs: []
    };
  },
  filters: {
    formatLongText(txt) {
      if (txt) {
        return txt.length > 15 ? `${txt.slice(0, 15)}...` : `${txt}`;
      }
      return "-";
    }
  },
  mounted() {
    this.$store.commit("integration/setIntegration", this.integration);
    this.dispatch();
    this.$store.dispatch("product/get", { limit: 1000 });
  },
  computed: {
    ...mapState("integration", ["integrationList", "pagination"]),
    ...mapState("product", ["products"])
  },
  methods: {
    statusClass(s) {
      return s ? "active-badge" : "inactive-badge";
    },

    searching(v) {
      this.search = v;
      this.dispatch();
    },
    productName(item) {
      return get(
        this.products.find(p => p.id === get(item.events[0], "product_id")),
        "name",
        "-"
      );
    },
    copyUrl(i) {
      navigator.clipboard.writeText(i.url);
      this.$message.success("Url copiada.");
    },

    getActions(item) {
      return [
        {
          text: item.status ? "Desativar" : "Ativar",
          icon: "fa-solid fa-power-off",
          confirmation: {
            enable: false
          },
          event: "change-status"
        },
        {
          text: "Editar",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false
          },
          event: "edit"
        },
        {
          text: "Excluir integração",
          class: "text-danger",
          icon: "fa-solid fa-trash",
          confirmation: {
            newDesign: true,
            enable: true,
            submitButtonClass: "btn-danger",
            text: "Deseja mesmo excluir esta integração?"
          },
          event: "delete"
        }
      ];
    },

    add() {
      this.integrationToEdit = null;
      this.modal = true;
    },
    edit(item) {
      this.integrationToEdit = item;
      this.modal = true;
    },

    changeStatus(item) {
      let data = { ...item, status: !item.status };
      this.$store
        .dispatch("integration/putIntegration", data)
        .then(({ data }) => {
          this.$store.commit(
            "integration/setIntegrationList",
            updateArrayItem(this.integrationList, data)
          );
          this.$message.success(
            `Integração ${data.status ? "ativada" : "desativada"}`
          );
        })
        .catch(error => {
          let msg = get_error_msg(
            error.response.data,
            TRANSLATE_FIELD_INTEGRATION_MAP,
            "Não foi possível alterar o status da integração"
          );
          this.$message.error(msg);
        });
    },
    submitDelete(item) {
      this.$store
        .dispatch("integration/deleteIntegration", item.id)
        .then(() => {
          this.refresh();
          this.$message.success("Integração removida");
        })
        .catch(error => {
          let msg = get_error_msg(
            error.response.data,
            TRANSLATE_FIELD_INTEGRATION_MAP,
            "Não foi possível deletar a conta integrada"
          );
          this.$message.error(msg);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    testWebhook(item) {
      let data = { url: item.url };
      if (item.internal_id) {
        data.external_id = item.internal_id;
      }
      this.$store
        .dispatch("integration/testWebhook", data)
        .then(() => this.$message.success("Teste enviado"))
        .catch(() => {
          this.$message.error("Não foi possível enviar o teste");
        });
    },

    refresh() {
      this.page = 1;
      this.dispatch();
    },
    dispatch(offset = 0) {
      if (this.offset === 0 && this.$refs.paginator)
        return this.$refs.paginator.reset();

      let params = { offset, search: this.search };

      this.loading = true;
      this.$store
        .dispatch("integration/getIntegration", clearObject(params))
        .catch(() => {
          this.$message.error("Não foi possível carregar as integrações");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
